import { useUnsubscribeAdminNewsletterSubscriberMutation } from '@codezo/graphql';
import { useThemeColors } from '@codezo/theme';
import { Anchor, Box, Button, Paper, Stack, Text } from '@mantine/core';
import { IconCheck, IconMailOff } from '@tabler/icons-react';
import { useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Logo } from '../components/common/Logo';

export function UnsubscribePage() {
	const colors = useThemeColors();
	const [searchParams] = useSearchParams();
	const [done, setDone] = useState(false);

	const email = useMemo(() => {
		const raw = searchParams.get('email') || '';
		try {
			return atob(raw);
		} catch {
			return raw;
		}
	}, [searchParams]);

	const [unsubscribe, { loading }] = useUnsubscribeAdminNewsletterSubscriberMutation({
		onCompleted: () => setDone(true),
		onError: () => setDone(true),
	});

	const handleUnsubscribe = () => {
		if (!email) return;
		unsubscribe({ variables: { email } });
	};

	const resubscribeLink = `/resubscribe?email=${searchParams.get('email') || ''}`;

	return (
		<Box
			style={{
				minHeight: '100vh',
				backgroundColor: colors.background,
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				padding: '16px',
			}}
		>
			<Paper withBorder shadow="xs" p="xl" radius="md" w={420}>
				<Stack align="center" gap="md">
					<Logo height={28} />

					{done ? (
						<>
							<IconCheck size={48} stroke={1.5} />
							<Text size="lg" fw={600} ta="center">
								You have been unsubscribed
							</Text>
							<Text size="sm" c="dimmed" ta="center">
								You will no longer receive newsletter emails from us.
							</Text>
							<Anchor component={Link} to={resubscribeLink} size="sm">
								Changed your mind? Resubscribe
							</Anchor>
						</>
					) : (
						<>
							<IconMailOff size={48} stroke={1.5} />
							<Text size="lg" fw={600} ta="center">
								Unsubscribe from newsletter
							</Text>
							{email ? (
								<>
									<Text size="sm" c="dimmed" ta="center">
										Click the button below to unsubscribe{' '}
										<Text span fw={500}>
											{email}
										</Text>{' '}
										from our newsletter.
									</Text>
									<Button
										color="dark"
										fullWidth
										onClick={handleUnsubscribe}
										loading={loading}
										mt="sm"
									>
										Unsubscribe
									</Button>
								</>
							) : (
								<Text size="sm" c="dimmed" ta="center">
									Invalid unsubscribe link. Please use the link from your email.
								</Text>
							)}
						</>
					)}
				</Stack>
			</Paper>
		</Box>
	);
}
